const system_limit = {
    limit_exceeded: 'Bạn đã đạt giới hạn hệ thống. Vui lòng liên hệ bộ phận hỗ trợ.',
};
export default Object.freeze(system_limit);
